import {
  getUserRecommendations,
  getGenericRecommendations
} from 'shared/models/api';

export const USER_RECOMMENDATIONS = 'USER_RECOMMENDATIONS';

const initialState = {
  userRecommendations: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case USER_RECOMMENDATIONS:
      return { ...state, userRecommendations: action.recommendations };
    default:
      return state;
  }
}

export function loadUserRecommendations() {
  return (dispatch, getState) => {
    const user = getState().login.user;
    const req = user
      ? getUserRecommendations(user)
      : getGenericRecommendations();
    return req.then(recommendations =>
      dispatch({ type: USER_RECOMMENDATIONS, recommendations })
    );
  };
}



// WEBPACK FOOTER //
// ./shared/components/recommendation/actions.js